import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const RnWelcomeLetter = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 4;

  const [formData] = useState({
    employeeId: "",
    employeeName: "",
    dateOfHire: "",
    immediateSupervisor: "SHEAVA BIDARI, MSN",
    // Rates of Pay for RN
    initialAssessmentRate: "$140.00",
    recertificationRate: "$100.00",
    resumptionRate: "$120.00",
    dischargeRate: "$65.00",
    regularVisitRate: "$55.00",
    ivInfusionRate: "$60.00",
    iv2HourlyRate: "$50.00",
    bloodDrawRate: "$50.00",
    initialAssessmentRate2: "$100.00",
    // Probationary Period
    probationaryPeriodEndDate: "",
    // Signature fields
    employeeSignature: "",
    employeeSignatureDate: "",
    // Initials for Page 2
    page2Initial1: "",
    page2Initial2: "",
    // Initials for Page 3
    page3Initial: "",
    // Initials for Page 4
    page4Initial: "",
  });



  const formatDateUS = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString + "T00:00:00");
      if (isNaN(date.getTime())) return "";
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    } catch {
      return "";
    }
  };

  // Render Page 1
  const renderPage1 = () => {
    return (
      <div className="bg-white p-8 max-w-4xl mx-auto" style={{ minHeight: '11in' }}>
        <div className="text-center mb-6">
          <div className="text-xl font-bold mb-2">Infinite Home Health, Inc.</div>
          <div className="text-lg font-bold underline mb-1">EMPLOYEE'S WELCOME LETTER</div>
          <div className="text-lg font-bold underline mb-1">AND</div>
          <div className="text-lg font-bold underline mb-4">AGREEMENT</div>
        </div>

        <div className="mb-4 text-sm leading-relaxed">
          <p>Dear <span className="inline-block border-b border-black min-w-[400px] px-2">{formData.employeeName || ""}</span>,</p>
          <p className="mt-2">We at Infinite Home Health welcome you to our office and we want you to know that we have established an open line of communication with all our employees. Please feel free to speak to us at any time. Kindly note that:</p>
          <p className="mt-2">Your Official Date of Hire is: <span className="inline-block border-b border-black min-w-[250px] px-2">{formatDateUS(formData.dateOfHire) || ""}</span></p>
          <p className="mt-2">Your Immediate Supervisor is: <span className="inline-block border-b border-black min-w-[250px] px-2">{formData.immediateSupervisor || "SHEAVA BIDARI, MSN"}</span></p>
        </div>

        <div className="font-bold text-sm mt-4 mb-2">Rates of Pay for RN:</div>
        <table className="w-full text-sm mb-4">
          <tbody>
            <tr><td className="font-semibold w-2/3 py-1">Initial Assessment:</td><td className="py-1">{formData.initialAssessmentRate || "$140.00"} Per Assessment</td></tr>
            <tr><td className="font-semibold py-1">Recertification:</td><td className="py-1">{formData.recertificationRate || "$100.00"} Per Recertification</td></tr>
            <tr><td className="font-semibold py-1">Resumption:</td><td className="py-1">{formData.resumptionRate || "$120.00"} Per Resumption</td></tr>
            <tr><td className="font-semibold py-1">Discharge:</td><td className="py-1">{formData.dischargeRate || "$65.00"} Per Discharge</td></tr>
            <tr><td className="font-semibold py-1">Regular Visit:</td><td className="py-1">{formData.regularVisitRate || "$55.00"} Per Visit (Includes Wound Care)</td></tr>
            <tr><td className="font-semibold py-1">IV Infusion:</td><td className="py-1">{formData.ivInfusionRate || "$60.00"} Per Visit (${formData.iv2HourlyRate || "50.00"} IV2 hourly infusions)</td></tr>
            <tr><td className="font-semibold py-1">Blood Draw:</td><td className="py-1">{formData.bloodDrawRate || "$50.00"} Per Visit</td></tr>
            <tr><td className="font-semibold py-1">Initial Assessment:</td><td className="py-1">{formData.initialAssessmentRate2 || "$100.00"} per Assessment</td></tr>
          </tbody>
        </table>

        <div className="text-sm leading-relaxed mb-4">
          <p>Your Probationary Period ends three months after your date of hire/your first patient care; on <span className="inline-block border-b border-black min-w-[250px] px-2">{formatDateUS(formData.probationaryPeriodEndDate) || ""}</span> which your performance will be evaluated and there will be yearly evaluation thereafter. Full time Employee's Benefits begin after the probationary period (if applicable). Physical Exams and Chest X-Rays are due every two years; however, the PPD is only valid for one year.</p>
          <p className="mt-2">You are expected to review our Policies and Procedures and you agree that you have Reviewed AND Understood our Safety Rules, Labor Laws/Sexual Harassment Rules, our Dress Code, your Job Description, Patient/Employee Confidentiality, our Policy on Child and Elder Abuse and you have Filled out all the required information accurately, to the best of your knowledge.</p>
          <p className="mt-2">In accordance with our policy and procedures we ask you kindly to submit any CEU's for your In-Service file.</p>
        </div>

        <div className="font-bold text-sm mt-4 mb-2">AGREEMENT</div>

        <div className="font-bold underline text-sm mt-4 mb-2">1- CONFIDENTIALITY STATEMENT</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>I understand that in the performance of my duties as an employee of Infinite Home Health, Inc., I may have access to, and may be involved in the processing of patient information. I understand that I am obligated to maintain the confidentiality of this patient information at all times, both at work and off duty.</p>
          <p className="mt-2 ml-4">• I understand that violation of these confidentiality considerations may result in disciplinary action, including termination. I further understand that I could be subjected to legal action.</p>
          <p className="mt-2 ml-4">• I understand that I am not to interpret, discuss, or otherwise relay medical or personal information about the patients, unless necessary during the course of fulfilling my job duties.</p>
          <p className="mt-2 ml-4">• I certify by my signature that, I have participated in the orientation and training concerning the privacy and confidentiality considerations of the Patient's Information.</p>
        </div>

        <div className="font-bold underline text-sm mt-4 mb-2">2- Child Abuse Reporting Requirements</div>
        <div className="text-sm leading-relaxed">
          <p>Section 11166 of the Penal Code requires that any childcare custodian, health practitioner or employee of a child protective agency who has knowledge of or observes a child in his or her professional capacity or within the scope of his or her employment that he or she knows or reasonably suspects has been the victim of child abuse to report the known or suspected instance of child abuse to a child protective agency immediately or as soon as practically possible by telephone and to prepare and send a written report thereof within 36 hours of receiving the information concerning the incident.</p>
        </div>
      </div>
    );
  };

  // Render Page 2
  const renderPage2 = () => {
    return (
      <div className="bg-white p-8 max-w-4xl mx-auto" style={{ minHeight: '11in' }}>
        <div className="font-bold underline text-sm mb-2">"Child Care Custodian"</div>
        <div className="text-xs leading-relaxed mb-4">
          <p>This includes, but is not limited to, teachers, instructional aides, teacher's aides, or teacher's assistants employed by public or private schools (with specific training and school district warranting to the State Department of Education), classified employees of public schools (with specific training and school warranting to the State Department of Education), administrative officers, supervisors of child welfare and attendance, or certified pupil personnel employees of any public or private school, administrators of public or private day camps, and administrators and employees of public or private youth centers, youth recreation programs, and youth organizations, administrators or employees of public or private organizations whose duties require direct contact and supervision of children and who have been trained in the duties imposed by this article, licenses, administrators, and employees of licensed community care of child day care facilities, head start teachers, licensing worker or licensing evaluators, public assistance workers, employees of a child care institution, including foster parents, group home personnel, and personnel of residential care facilities, social workers, probation officers, or parole officers, employees of a school district police or security department, any person who is an administrator or presenter of, or counselor in, a child abuse prevention program in any public or private school.</p>
        </div>

        <div className="font-bold underline text-sm mb-2">"Health Practitioner"</div>
        <div className="text-xs leading-relaxed mb-4">
          <p>This includes, but is not limited to, physicians and surgeons, psychiatrists, psychologists, dentists, residents, interns, podiatrists, chiropractors, licensed nurses, dental hygienists, optometrists, or any other person licensed under Division 2 (commencing with Section 500) of the Business & Professional Code, marriage, family, and child counselors, emergency medical technicians I or II, paramedics, or other persons certified pursuant to Division 25 (commencing with Section 1797) of the Health & Safety Code, psychological assistants registered pursuant to Section 2913 of the Business & Professional Code, marriage, family, and child counselor trainee, as defined in subdivision (C) of Section 4980.03 of the Business & Professional Code, state or county public health employees who treat minors for venereal disease or any other condition, coroners, paramedics, religious practitioners who diagnose, examine, or treat children.</p>
        </div>

        <div className="font-bold underline text-sm mb-2">3- Elder and Dependant Adult Abuse Reporting Responsibility</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>The California legislature has adopted mandatory reporting requirements for dependent adult and elder abuse. Two aspects of the law are of particular concern to physicians:</p>
          <p className="mt-2 ml-4">• The scope of a physician's reporting obligation under the law.</p>
          <p className="mt-2 ml-4">• The obligation of all physicians and other employers of licensed health care practitioners or other mandated reporters to provide employees with a statement explaining reporting obligations and to obtain a signed acknowledgment from those hired on or after January 1, 1986.</p>
        </div>

        <div className="font-bold text-sm mb-2">Mandatory Reporting:</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>Physicians, nurses, pharmacies, all other medical practitioners licensed under Division 2 of the Business and Professional Code. Also, certain non-medical practitioners such as coroners, social workers, psychologists, family counselors, nursing home ombudsmen, care custodians (individuals working directly with elders or dependent adults as part of their official duties), law officers, and probation and welfare personnel.</p>
          <p className="mt-2">The obligation does not extend to physician's office support staff who are not licensed health care providers.</p>
          <p className="mt-2">One individual may make the required report for an entire group, and facilities can develop reporting protocols consistent with statutory requirements. If a group member learns that the designated individual has failed to make the report, that member must make the report as soon as practically possible.</p>
        </div>

        <div className="font-bold text-sm mb-2">Abuse Which Must Be Reported:</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>Those subject to the obligation must report if, within their professional capacity or scope of employment, they:</p>
          <p className="mt-2 ml-4">1. Observe an incident that reasonably appears to be physical abuse.</p>
          <p className="mt-2 ml-4">2. Observe a physical injury where its nature, location on the body, or repetition clearly indicates physical abuse has occurred.</p>
          <p className="mt-2 ml-4">3. Are told by an elder or dependent adult that they have experienced behavior constituting physical abuse.</p>
        </div>

        <div className="mt-6">
          <p className="text-sm">Employee Signature: <span className="inline-block border-b border-black min-w-[300px] px-2">{formData.employeeSignature || ""}</span></p>
          <p className="text-sm mt-2">Date: <span className="inline-block border-b border-black min-w-[300px] px-2">{formatDateUS(formData.employeeSignatureDate) || ""}</span></p>
        </div>

        <div className="text-right mt-6">
          <p className="text-sm">(initial) <span className="inline-block border-b border-black min-w-[100px] px-2">{formData.page2Initial1 || ""}</span></p>
          <p className="text-sm mt-4">(initial) <span className="inline-block border-b border-black min-w-[100px] px-2">{formData.page2Initial2 || ""}</span></p>
        </div>
      </div>
    );
  };

  // Render Page 3
  const renderPage3 = () => {
    return (
      <div className="bg-white p-8 max-w-4xl mx-auto" style={{ minHeight: '11in' }}>
        <div className="font-bold underline text-sm mb-2">"Physical abuse"</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>"Physical abuse" which must be reported includes in addition to physical or sexual assault or barrier, the use of physical or chemical restraints or psychotropic medication:</p>
          <p className="mt-2 ml-4">1. For punishment;</p>
          <p className="mt-2 ml-4">2. For a period of time significantly longer than that for which the restraint or medication was authorized by the instructions of a physician providing medical care to the elder or dependent adult at the time the instructions were given; or</p>
          <p className="mt-2 ml-4">3. For any purpose not consistent with the authorization of the physician. It is the opinion of CNIA legal counsel that the law does not require reporting of cases involving the appropriate withholding or removal of life-sustaining treatment as otherwise authorize by law.</p>
        </div>

        <div className="font-bold underline text-sm mb-2">"Dependent adults"</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>"Dependent adults" covered by the law include any person residing in California between the ages of 18 and 64 who have physical or mental limitations which restrict their ability to carryout normal activities and protect their rights, and specifically includes all hospital inpatients.</p>
        </div>

        <div className="font-bold underline text-sm mb-2">"Elders"</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>"Elders" covered by the law include all persons residing in California 65 years of age or older.</p>
        </div>

        <div className="font-bold text-sm mb-2">Discretionary Reporting:</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>Those required to report physical abuse as described above may, but are not required to report known or reasonably suspected instances of other types of elder or dependent adult abuse, including cases of mental abuse, fiduciary abuse, neglect, abandonment, isolation, or other treatment with resulting physical harm or pain or mental suffering, or the deprivation by a care custodian of goods or services that are necessary to avoid physical harm or mental suffering.</p>
        </div>

        <div className="font-bold underline text-sm mb-2">"Isolation"</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>"Isolation" includes:</p>
          <p className="mt-2 ml-4">1. Acts intended to prevent, and that do prevent, an elder or dependent adult from receiving mail or telephone calls.</p>
          <p className="mt-2 ml-4">2. Telling a caller of prospective visitor that an elder or dependent adult is not present, or does not wish to talk with the caller or to meet with the visitor, where the statement is false, contrary to the express wishes of the elder or dependent adult from having contact with family, friends or concerned persons;</p>
          <p className="mt-2 ml-4">3. False imprisonment (as defined in Penal Code 236); and</p>
          <p className="mt-2 ml-4">4. Physical restraint of an elder or dependent adult for the purpose of preventing the person from meeting with visitors.</p>
          <p className="mt-2">The above acts are subject to a rebuttal presumption that they do not constitute isolation if they are performed pursuant to the instructions of a physician who is caring for the elder or dependent adult and who gives the instructions as part of the person's medical care. Furthermore, the above acts do not constitute isolation if they are performed in response to a reasonably perceived threat of danger to property or physical safety.</p>
        </div>

        <div className="font-bold text-sm mb-2">Reports:</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>Reports by telephone and in writing must be made to:</p>
          <p className="mt-2 ml-4">1. The long term care ombudsman coordinator or local law enforcement agency (the city police or County sheriffs department, or county probation's department) when the abuse is alleged to have occurred in a long-term care facility; or</p>
          <p className="mt-2 ml-4">2. To the county adult protective services agency (County Welfare Department) or a local law enforcement agency when the abuse is alleged to have occurred anywhere else.</p>
          <p className="mt-2">Both the telephone and written report should include unless the information is unavailable to the reporter, the name, address, telephone number and occupation of the person making the report, the name and address of the victim, the date, time and place of the incident, other details, including the reporter's observations and beliefs concerning the incident, any statement relating to the incident, and the name of the individuals believed to be responsible for the incident and their connection to the victim. The written report is to be on a standardized form which should be available from County adult protective services agencies, and must be sent within two working days of notice of the abuse.</p>
        </div>

        <div className="font-bold underline text-sm mb-2 mt-6">4- NON-HARASSMENT POLICY</div>
        <div className="text-sm leading-relaxed">
          <p>Infinite Home Health, Inc. is committed to providing a work environment free of unlawful harassment. Company policy prohibits sexual harassment, and harassment based on pregnancy, childbirth or related medical conditions, race, religious creed, color, national origin or ancestry, physical or mental disability, medical condition, marital status, age, sexual orientation, or any other basis protected by federal, state or local law, ordinance, or regulation. All such harassment is unlawful.</p>
        </div>

        <div className="text-right mt-10">
          <p className="text-sm">(initial) <span className="inline-block border-b border-black min-w-[100px] px-2">{formData.page3Initial || ""}</span></p>
        </div>
      </div>
    );
  };

  // Render Page 4
  const renderPage4 = () => {
    return (
      <div className="bg-white p-8 max-w-4xl mx-auto" style={{ minHeight: '11in' }}>
        <div className="text-sm leading-relaxed mb-4">
          <p>Infinite Home Health's anti-harassment policy applies to all personnel, including managers, supervisors, and co-workers.</p>
        </div>

        <div className="font-bold text-sm mb-2 mt-4">Prohibited unlawful harassment:</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>Harassment includes, but is not limited to:</p>
          <p className="mt-2 ml-4">a. Verbal conduct such as epithets, derogatory jokes, slurs, unwanted sexual advances, propositions, or comments.</p>
          <p className="mt-2 ml-4">b. Visual conduct such as derogatory and/or sexually-oriented posters, photography, cartoons, drawings, gestures, or other sexually graphic material.</p>
          <p className="mt-2 ml-4">c. Physical conduct such as assault, unwanted touching, blocking normal movement, or interfering with work directed at an individual because of his/her sex, race, or other protected basis.</p>
          <p className="mt-2 ml-4">d. Threats and demands to submit to sexual requests as a condition of continued employment or benefits in return for sexual favors, or unwelcome sexual advances which condition an employment benefit upon an exchange of sexual favors.</p>
          <p className="mt-2 ml-4">e. Retaliation for having reported or threatened to report harassment.</p>
        </div>

        <div className="font-bold text-sm mb-2 mt-4">Procedure for reporting harassment:</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>If you believe that you have been subjected to harassment, you should make a written complaint to your supervisor or the Agency's Administrator. You may choose to report to a person of your own sex. Complaints should include details of the incident or incidents, names of the individuals involved, and names of any witnesses.</p>
          <p className="mt-2">Supervisors are to refer all complaints to the Administrator. The Agency's Administrator will undertake an effective, thorough and objective investigation of the harassment allegations.</p>
          <p className="mt-2">If unlawful harassment is determined to have occurred, remedial action will be taken. Any such action may range from counseling to termination of employment, and may include such other forms of disciplinary action as deemed appropriate under the circumstances. Any employee determined by Infinite Home Health, Inc. to be responsible for unlawful harassment will be subject to appropriate disciplinary action, up to and including termination.</p>
        </div>

        <div className="font-bold underline text-sm mb-2 mt-6">5- Handbook Acknowledgement</div>
        <div className="text-sm leading-relaxed mb-4">
          <p>I acknowledge that I have received the Employee Handbook. I understand that it contains information regarding personnel policies, privileges, and obligations. I agree to read and comply with the materials contained in the Handbook. I also understand that if I have any questions concerning any provisions of the Handbook, I will contact Infinite Home Health, Inc. for clarification.</p>
          <p className="mt-2">I understand that Infinite Home Health, Inc. may change, supplement, or rescind any policies, benefits, or practices described in the Handbook from time to time in its sole discretion, with or without prior notice to me, except for employment at-will provisions.</p>
          <p className="mt-2">I understand that no statement in the Handbook or other company policies (including performance appraisals) should be construed as an expressed or implied promise of continuing employment, unless explicitly agreed upon and confirmed in writing by both the Company and me.</p>
          <p className="mt-2">I understand that, other than the Administrator of Infinite Home Health, Inc., no manager, supervisor, or representative has the authority to enter into any employment agreement (expressed or implied) for any period of time, or to make any agreement for employment other than at-will. Only the Administrator has this authority, and only in writing and signed by the Administrator.</p>
          <p className="mt-2">I understand that my employment with Infinite Home Health, Inc. is at the mutual consent of the employee and Infinite Home Health, Inc. Accordingly, either I or Infinite Home Health, Inc. can terminate the employment relationship at-will, with or without cause, at any time.</p>
        </div>

        <div className="font-bold underline text-sm mb-2 mt-6">6- ACKNOWLEDGEMENT OF UNIVERSAL PRECAUTIONS</div>
        <div className="text-sm leading-relaxed">
          <p>I, the undersigned employee, have been given guidelines on AIDS and Hepatitis B, as well as a copy of the policy and procedure on Universal Precautions.</p>
          <p className="mt-2 font-bold">NOTE: The Center of Disease Control (CDC) advises that your greatest risk is up to twelve weeks after exposure to the blood borne pathogens.</p>
        </div>

        <div className="text-right mt-8">
          <p className="text-sm">(initial) <span className="inline-block border-b border-black min-w-[100px] px-2">{formData.page4Initial || ""}</span></p>
        </div>
      </div>
    );
  };

  // Generate print HTML (keeping the same structure)
  const generatePrintFormHTML = (data) => {
    return `
      <!DOCTYPE html>
      <html>
      <head>
        <title>RN Welcome Letter - ${data.employeeName || "Employee"}</title>
        <style>
          @media print {
            @page {
              margin: 0.5in;
              size: letter;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .page-break {
              page-break-after: always;
            }
          }
          * {
            box-sizing: border-box;
          }
          body {
            font-family: 'Times New Roman', serif;
            font-size: 11pt;
            line-height: 1.4;
            color: #000;
            padding: 20px;
          }
          .header {
            text-align: center;
            margin-bottom: 20px;
          }
          .company-name {
            font-size: 16pt;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .title {
            font-size: 14pt;
            font-weight: bold;
            text-decoration: underline;
            margin-bottom: 15px;
          }
          .welcome-text {
            margin-bottom: 20px;
            line-height: 1.6;
          }
          .form-line {
            border-bottom: 1px solid #000;
            min-height: 20px;
            display: inline-block;
            min-width: 300px;
            margin: 0 5px;
            padding-bottom: 2px;
          }
          .form-line-large {
            border-bottom: 1px solid #000;
            min-height: 20px;
            display: inline-block;
            min-width: 500px;
            padding-bottom: 2px;
          }
          .section-title {
            font-weight: bold;
            font-size: 12pt;
            margin-top: 15px;
            margin-bottom: 10px;
          }
          .rates-table {
            width: 100%;
            border-collapse: collapse;
            margin: 10px 0;
          }
          .rates-table td {
            padding: 5px 10px;
            border-bottom: 1px solid #ccc;
          }
          .rates-table td:first-child {
            font-weight: bold;
            width: 60%;
          }
          .bullet-point {
            margin-left: 20px;
            margin-top: 5px;
            margin-bottom: 5px;
          }
          .signature-section {
            margin-top: 30px;
            margin-bottom: 20px;
          }
          .page-break {
            page-break-after: always;
          }
          .subsection-title {
            font-weight: bold;
            text-decoration: underline;
            margin-top: 15px;
            margin-bottom: 10px;
          }
          .initial-line {
            border-bottom: 1px solid #000;
            min-height: 15px;
            display: inline-block;
            min-width: 100px;
            margin: 0 3px;
          }
        </style>
      </head>
      <body>
        <!-- PAGE 1 -->
        <div class="header">
          <div class="company-name">Infinite Home Health, Inc.</div>
          <div class="title">EMPLOYEE'S WELCOME LETTER</div>
          <div class="title">AND</div>
          <div class="title">AGREEMENT</div>
        </div>

        <div class="welcome-text">
          <p>Dear <span class="form-line-large">${data.employeeName || ""}</span>,</p>
          <p>We at Infinite Home Health welcome you to our office and we want you to know that we have established an open line of communication with all our employees. Please feel free to speak to us at any time. Kindly note that:</p>
          <p>Your Official Date of Hire is: <span class="form-line">${formatDateUS(data.dateOfHire) || ""}</span></p>
          <p>Your Immediate Supervisor is: <span class="form-line">${data.immediateSupervisor || "SHEAVA BIDARI, MSN"}</span></p>
        </div>

        <div class="section-title">Rates of Pay for RN:</div>
        <table class="rates-table">
          <tr>
            <td>Initial Assessment:</td>
            <td>${data.initialAssessmentRate || "$140.00"} Per Assessment</td>
          </tr>
          <tr>
            <td>Recertification:</td>
            <td>${data.recertificationRate || "$100.00"} Per Recertification</td>
          </tr>
          <tr>
            <td>Resumption:</td>
            <td>${data.resumptionRate || "$120.00"} Per Resumption</td>
          </tr>
          <tr>
            <td>Discharge:</td>
            <td>${data.dischargeRate || "$65.00"} Per Discharge</td>
          </tr>
          <tr>
            <td>Regular Visit:</td>
            <td>${data.regularVisitRate || "$55.00"} Per Visit (Includes Wound Care)</td>
          </tr>
          <tr>
            <td>IV Infusion:</td>
            <td>${data.ivInfusionRate || "$60.00"} Per Visit ($${data.iv2HourlyRate || "50.00"} IV2 hourly infusions)</td>
          </tr>
          <tr>
            <td>Blood Draw:</td>
            <td>${data.bloodDrawRate || "$50.00"} Per Visit</td>
          </tr>
          <tr>
            <td>Initial Assessment:</td>
            <td>${data.initialAssessmentRate2 || "$100.00"} per Assessment</td>
          </tr>
        </table>

        <div class="welcome-text">
          <p>Your Probationary Period ends three months after your date of hire/your first patient care; on <span class="form-line">${formatDateUS(data.probationaryPeriodEndDate) || ""}</span> which your performance will be evaluated and there will be yearly evaluation thereafter. Full time Employee's Benefits begin after the probationary period (if applicable). Physical Exams and Chest X-Rays are due every two years; however, the PPD is only valid for one year.</p>
          <p>You are expected to review our Policies and Procedures and you agree that you have Reviewed AND Understood our Safety Rules, Labor Laws/Sexual Harassment Rules, our Dress Code, your Job Description, Patient/Employee Confidentiality, our Policy on Child and Elder Abuse and you have Filled out all the required information accurately, to the best of your knowledge.</p>
          <p>In accordance with our policy and procedures we ask you kindly to submit any CEU's for your In-Service file.</p>
        </div>

        <div class="section-title">AGREEMENT</div>
        
        <div class="subsection-title">1- CONFIDENTIALITY STATEMENT</div>
        <div class="welcome-text">
          <p>I understand that in the performance of my duties as an employee of Infinite Home Health, Inc., I may have access to, and may be involved in the processing of patient information. I understand that I am obligated to maintain the confidentiality of this patient information at all times, both at work and off duty.</p>
          <div class="bullet-point">• I understand that violation of these confidentiality considerations may result in disciplinary action, including termination. I further understand that I could be subjected to legal action.</div>
          <div class="bullet-point">• I understand that I am not to interpret, discuss, or otherwise relay medical or personal information about the patients, unless necessary during the course of fulfilling my job duties.</div>
          <div class="bullet-point">• I certify by my signature that, I have participated in the orientation and training concerning the privacy and confidentiality considerations of the Patient's Information.</div>
        </div>

        <div class="subsection-title">2- Child Abuse Reporting Requirements</div>
        <div class="welcome-text">
          <p>Section 11166 of the Penal Code requires that any childcare custodian, health practitioner or employee of a child protective agency who has knowledge of or observes a child in his or her professional capacity or within the scope of his or her employment that he or she knows or reasonably suspects has been the victim of child abuse to report the known or suspected instance of child abuse to a child protective agency immediately or as soon as practically possible by telephone and to prepare and send a written report thereof within 36 hours of receiving the information concerning the incident.</p>
        </div>

        <!-- PAGE BREAK -->
        <div class="page-break"></div>

        <!-- PAGE 2 -->
        <div class="subsection-title">"Child Care Custodian"</div>
        <div class="welcome-text" style="font-size: 10pt;">
          <p>This includes, but is not limited to, teachers, instructional aides, teacher's aides, or teacher's assistants employed by public or private schools (with specific training and school district warranting to the State Department of Education), classified employees of public schools (with specific training and school warranting to the State Department of Education), administrative officers, supervisors of child welfare and attendance, or certified pupil personnel employees of any public or private school, administrators of public or private day camps, and administrators and employees of public or private youth centers, youth recreation programs, and youth organizations, administrators or employees of public or private organizations whose duties require direct contact and supervision of children and who have been trained in the duties imposed by this article, licenses, administrators, and employees of licensed community care of child day care facilities, head start teachers, licensing worker or licensing evaluators, public assistance workers, employees of a child care institution, including foster parents, group home personnel, and personnel of residential care facilities, social workers, probation officers, or parole officers, employees of a school district police or security department, any person who is an administrator or presenter of, or counselor in, a child abuse prevention program in any public or private school.</p>
        </div>

        <div class="subsection-title">"Health Practitioner"</div>
        <div class="welcome-text" style="font-size: 10pt;">
          <p>This includes, but is not limited to, physicians and surgeons, psychiatrists, psychologists, dentists, residents, interns, podiatrists, chiropractors, licensed nurses, dental hygienists, optometrists, or any other person licensed under Division 2 (commencing with Section 500) of the Business & Professional Code, marriage, family, and child counselors, emergency medical technicians I or II, paramedics, or other persons certified pursuant to Division 25 (commencing with Section 1797) of the Health & Safety Code, psychological assistants registered pursuant to Section 2913 of the Business & Professional Code, marriage, family, and child counselor trainee, as defined in subdivision (C) of Section 4980.03 of the Business & Professional Code, state or county public health employees who treat minors for venereal disease or any other condition, coroners, paramedics, religious practitioners who diagnose, examine, or treat children.</p>
        </div>

        <div class="subsection-title">3- Elder and Dependant Adult Abuse Reporting Responsibility</div>
        <div class="welcome-text">
          <p>The California legislature has adopted mandatory reporting requirements for dependent adult and elder abuse. Two aspects of the law are of particular concern to physicians:</p>
          <div class="bullet-point">• The scope of a physician's reporting obligation under the law.</div>
          <div class="bullet-point">• The obligation of all physicians and other employers of licensed health care practitioners or other mandated reporters to provide employees with a statement explaining reporting obligations and to obtain a signed acknowledgment from those hired on or after January 1, 1986.</div>
        </div>

        <div class="subsection-title">Mandatory Reporting:</div>
        <div class="welcome-text">
          <p>Physicians, nurses, pharmacies, all other medical practitioners licensed under Division 2 of the Business and Professional Code. Also, certain non-medical practitioners such as coroners, social workers, psychologists, family counselors, nursing home ombudsmen, care custodians (individuals working directly with elders or dependent adults as part of their official duties), law officers, and probation and welfare personnel.</p>
          <p>The obligation does not extend to physician's office support staff who are not licensed health care providers.</p>
          <p>One individual may make the required report for an entire group, and facilities can develop reporting protocols consistent with statutory requirements. If a group member learns that the designated individual has failed to make the report, that member must make the report as soon as practically possible.</p>
        </div>

        <div class="subsection-title">Abuse Which Must Be Reported:</div>
        <div class="welcome-text">
          <p>Those subject to the obligation must report if, within their professional capacity or scope of employment, they:</p>
          <div class="bullet-point">1. Observe an incident that reasonably appears to be physical abuse.</div>
          <div class="bullet-point">2. Observe a physical injury where its nature, location on the body, or repetition clearly indicates physical abuse has occurred.</div>
          <div class="bullet-point">3. Are told by an elder or dependent adult that they have experienced behavior constituting physical abuse.</div>
        </div>

        <div class="signature-section">
          <p>Employee Signature: <span class="form-line">${data.employeeSignature || ""}</span></p>
          <p>Date: <span class="form-line">${formatDateUS(data.employeeSignatureDate) || ""}</span></p>
        </div>

        <div style="margin-top: 20px; text-align: right;">
          <p>(initial) <span class="initial-line">${data.page2Initial1 || ""}</span></p>
          <p style="margin-top: 15px;">(initial) <span class="initial-line">${data.page2Initial2 || ""}</span></p>
        </div>

        <!-- PAGE BREAK -->
        <div class="page-break"></div>

        <!-- PAGE 3 -->
        <div class="subsection-title">"Physical abuse"</div>
        <div class="welcome-text">
          <p>"Physical abuse" which must be reported includes in addition to physical or sexual assault or barrier, the use of physical or chemical restraints or psychotropic medication:</p>
          <div class="bullet-point">1. For punishment;</div>
          <div class="bullet-point">2. For a period of time significantly longer than that for which the restraint or medication was authorized by the instructions of a physician providing medical care to the elder or dependent adult at the time the instructions were given; or</div>
          <div class="bullet-point">3. For any purpose not consistent with the authorization of the physician. It is the opinion of CNIA legal counsel that the law does not require reporting of cases involving the appropriate withholding or removal of life-sustaining treatment as otherwise authorize by law.</div>
        </div>

        <div class="subsection-title">"Dependent adults"</div>
        <div class="welcome-text">
          <p>"Dependent adults" covered by the law include any person residing in California between the ages of 18 and 64 who have physical or mental limitations which restrict their ability to carryout normal activities and protect their rights, and specifically includes all hospital inpatients.</p>
        </div>

        <div class="subsection-title">"Elders"</div>
        <div class="welcome-text">
          <p>"Elders" covered by the law include all persons residing in California 65 years of age or older.</p>
        </div>

        <div class="subsection-title">Discretionary Reporting:</div>
        <div class="welcome-text">
          <p>Those required to report physical abuse as described above may, but are not required to report known or reasonably suspected instances of other types of elder or dependent adult abuse, including cases of mental abuse, fiduciary abuse, neglect, abandonment, isolation, or other treatment with resulting physical harm or pain or mental suffering, or the deprivation by a care custodian of goods or services that are necessary to avoid physical harm or mental suffering.</p>
        </div>

        <div class="subsection-title">"Isolation"</div>
        <div class="welcome-text">
          <p>"Isolation" includes:</p>
          <div class="bullet-point">1. Acts intended to prevent, and that do prevent, an elder or dependent adult from receiving mail or telephone calls.</div>
          <div class="bullet-point">2. Telling a caller of prospective visitor that an elder or dependent adult is not present, or does not wish to talk with the caller or to meet with the visitor, where the statement is false, contrary to the express wishes of the elder or dependent adult from having contact with family, friends or concerned persons;</div>
          <div class="bullet-point">3. False imprisonment (as defined in Penal Code 236); and</div>
          <div class="bullet-point">4. Physical restraint of an elder or dependent adult for the purpose of preventing the person from meeting with visitors.</div>
          <p style="margin-top: 10px;">The above acts are subject to a rebuttal presumption that they do not constitute isolation if they are performed pursuant to the instructions of a physician who is caring for the elder or dependent adult and who gives the instructions as part of the person's medical care. Furthermore, the above acts do not constitute isolation if they are performed in response to a reasonably perceived threat of danger to property or physical safety.</p>
        </div>

        <div class="subsection-title">Reports:</div>
        <div class="welcome-text">
          <p>Reports by telephone and in writing must be made to:</p>
          <div class="bullet-point">1. The long term care ombudsman coordinator or local law enforcement agency (the city police or County sheriffs department, or county probation's department) when the abuse is alleged to have occurred in a long-term care facility; or</div>
          <div class="bullet-point">2. To the county adult protective services agency (County Welfare Department) or a local law enforcement agency when the abuse is alleged to have occurred anywhere else.</div>
          <p style="margin-top: 10px;">Both the telephone and written report should include unless the information is unavailable to the reporter, the name, address, telephone number and occupation of the person making the report, the name and address of the victim, the date, time and place of the incident, other details, including the reporter's observations and beliefs concerning the incident, any statement relating to the incident, and the name of the individuals believed to be responsible for the incident and their connection to the victim. The written report is to be on a standardized form which should be available from County adult protective services agencies, and must be sent within two working days of notice of the abuse.</p>
        </div>

        <div class="subsection-title">4- NON-HARASSMENT POLICY</div>
        <div class="welcome-text">
          <p>Infinite Home Health, Inc. is committed to providing a work environment free of unlawful harassment. Company policy prohibits sexual harassment, and harassment based on pregnancy, childbirth or related medical conditions, race, religious creed, color, national origin or ancestry, physical or mental disability, medical condition, marital status, age, sexual orientation, or any other basis protected by federal, state or local law, ordinance, or regulation. All such harassment is unlawful.</p>
        </div>

        <div style="margin-top: 40px; text-align: right;">
          <p>(initial) <span class="initial-line">${data.page3Initial || ""}</span></p>
        </div>

        <!-- PAGE BREAK -->
        <div class="page-break"></div>

        <!-- PAGE 4 -->
        <div class="welcome-text">
          <p>Infinite Home Health's anti-harassment policy applies to all personnel, including managers, supervisors, and co-workers.</p>
        </div>

        <div class="subsection-title" style="margin-top: 15px;">Prohibited unlawful harassment:</div>
        <div class="welcome-text">
          <p>Harassment includes, but is not limited to:</p>
          <div class="bullet-point">a. Verbal conduct such as epithets, derogatory jokes, slurs, unwanted sexual advances, propositions, or comments.</div>
          <div class="bullet-point">b. Visual conduct such as derogatory and/or sexually-oriented posters, photography, cartoons, drawings, gestures, or other sexually graphic material.</div>
          <div class="bullet-point">c. Physical conduct such as assault, unwanted touching, blocking normal movement, or interfering with work directed at an individual because of his/her sex, race, or other protected basis.</div>
          <div class="bullet-point">d. Threats and demands to submit to sexual requests as a condition of continued employment or benefits in return for sexual favors, or unwelcome sexual advances which condition an employment benefit upon an exchange of sexual favors.</div>
          <div class="bullet-point">e. Retaliation for having reported or threatened to report harassment.</div>
        </div>

        <div class="subsection-title" style="margin-top: 15px;">Procedure for reporting harassment:</div>
        <div class="welcome-text">
          <p>If you believe that you have been subjected to harassment, you should make a written complaint to your supervisor or the Agency's Administrator. You may choose to report to a person of your own sex. Complaints should include details of the incident or incidents, names of the individuals involved, and names of any witnesses.</p>
          <p>Supervisors are to refer all complaints to the Administrator. The Agency's Administrator will undertake an effective, thorough and objective investigation of the harassment allegations.</p>
          <p>If unlawful harassment is determined to have occurred, remedial action will be taken. Any such action may range from counseling to termination of employment, and may include such other forms of disciplinary action as deemed appropriate under the circumstances. Any employee determined by Infinite Home Health, Inc. to be responsible for unlawful harassment will be subject to appropriate disciplinary action, up to and including termination.</p>
        </div>

        <div class="subsection-title" style="margin-top: 20px;">5- Handbook Acknowledgement</div>
        <div class="welcome-text">
          <p>I acknowledge that I have received the Employee Handbook. I understand that it contains information regarding personnel policies, privileges, and obligations. I agree to read and comply with the materials contained in the Handbook. I also understand that if I have any questions concerning any provisions of the Handbook, I will contact Infinite Home Health, Inc. for clarification.</p>
          <p>I understand that Infinite Home Health, Inc. may change, supplement, or rescind any policies, benefits, or practices described in the Handbook from time to time in its sole discretion, with or without prior notice to me, except for employment at-will provisions.</p>
          <p>I understand that no statement in the Handbook or other company policies (including performance appraisals) should be construed as an expressed or implied promise of continuing employment, unless explicitly agreed upon and confirmed in writing by both the Company and me.</p>
          <p>I understand that, other than the Administrator of Infinite Home Health, Inc., no manager, supervisor, or representative has the authority to enter into any employment agreement (expressed or implied) for any period of time, or to make any agreement for employment other than at-will. Only the Administrator has this authority, and only in writing and signed by the Administrator.</p>
          <p>I understand that my employment with Infinite Home Health, Inc. is at the mutual consent of the employee and Infinite Home Health, Inc. Accordingly, either I or Infinite Home Health, Inc. can terminate the employment relationship at-will, with or without cause, at any time.</p>
        </div>

        <div class="subsection-title" style="margin-top: 20px;">6- Acknowledgement of Universal Precautions</div>
        <div class="welcome-text">
          <p>I, the undersigned employee, have been given guidelines on AIDS and Hepatitis B, as well as a copy of the policy and procedure on Universal Precautions.</p>
          <p style="margin-top: 10px; font-weight: bold;">NOTE: The Center of Disease Control (CDC) advises that your greatest risk is up to twelve weeks after exposure to the blood borne pathogens.</p>
        </div>

        <div style="margin-top: 30px; text-align: right;">
          <p>(initial) <span class="initial-line">${data.page4Initial || ""}</span></p>
        </div>
      </body>
      </html>
    `;
  };

  const printForm = (data) => {
    const printHTML = generatePrintFormHTML(data);
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printHTML);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
    }, 250);
  };


  // Render current page based on currentPage state
  const renderCurrentPage = () => {
    switch (currentPage) {
      case 1:
        return renderPage1();
      case 2:
        return renderPage2();
      case 3:
        return renderPage3();
      case 4:
        return renderPage4();
      default:
        return renderPage1();
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">RN Welcome Letter and Agreement</h1>
        <button
          onClick={() => navigate("/forms")}
          className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600"
        >
          Back to Forms
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        {/* Page Navigation */}
        <div className="flex justify-between items-center mb-4 pb-4 border-b">
          <button
            type="button"
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Previous
          </button>
          <span className="text-lg font-semibold text-gray-700">
            Page {currentPage} of {totalPages}
          </span>
          <button
            type="button"
            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>

        {/* Page Display */}
        <div className="border border-gray-300 rounded-lg overflow-hidden bg-gray-50">
          {renderCurrentPage()}
        </div>

        {/* Print Button - Only show on last page */}
        {currentPage === totalPages && (
          <div className="flex gap-4 mt-6">
            <button
              type="button"
              onClick={() => {
                const submitData = {
                  ...formData,
                  employeeSignatureDate: formData.employeeSignatureDate || formData.dateOfHire,
                };
                printForm(submitData);
              }}
              className="flex-1 bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-md"
            >
              Print
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RnWelcomeLetter;
